const TWT = ({ ...props }) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M9.9692 20C15.4071 20 19.8154 15.5228 19.8154 10C19.8154 4.47716 15.4071 0 9.9692 0C4.53132 0 0.123047 4.47716 0.123047 10C0.123047 15.5228 4.53132 20 9.9692 20Z"
      fill="#3375BB"
    />
    <path
      d="M10.0389 4.375C11.9848 6.0255 14.2162 5.92372 14.8538 5.92372C14.7143 15.3105 13.6517 13.4492 10.0389 16.0812C6.42613 13.4492 5.37019 15.3105 5.23071 5.92372C5.86164 5.92372 8.09305 6.0255 10.0389 4.375Z"
      stroke="white"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);
export default TWT;
